import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 93DAA69E-9A21-4D5A-B6B1-0AF0A24B7FEB
 * name play-pause
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/play-pause.svg
 * tags
 * - Home Automation 
 */
export const PlayPauseIcon = createSvgIcon(<><path d="M3,5V19L11,12M13,19H16V5H13M18,5V19H21V5" /></>, 'PlayPauseIcon');
export default PlayPauseIcon